import type { Infer } from 'superstruct';
import {
	assign,
	boolean,
	nullable,
	number,
	object,
	optional,
	partial,
	string,
} from 'superstruct';

import {
	SalesforceAccount,
	SalesforceLocations,
} from '@adflow/shared/data-salesforce-import';
import {
	parsableInteger,
	stringDate,
	userString,
} from '@adflow/shared/util-superstruct';

import { ViewFacebookAdSetLocations } from './facebook-adset-location-template.dto';

export const AddFacebookAdAccountDto = object({
	id: optional(parsableInteger()),
	avbId: userString('validations:Required'),
	name: optional(string()),
	lastSavedAudienceId: optional(string()),
	lastSavedPageId: optional(string()),
	previousLocations: optional(
		assign(
			ViewFacebookAdSetLocations,
			object({ useSavedAudienceLocations: optional(boolean()) })
		)
	),
});

export const ViewFacebookAdAccountDto = object({
	id: number(),
	facebookId: nullable(string()),
	name: string(),
	avbId: string(),

	salesforceLocations: optional(SalesforceLocations),
	salesforceAccount: optional(SalesforceAccount),

	lastSavedAudienceId: optional(string()),
	lastSavedPageId: optional(string()),
	previousLocations: optional(
		assign(
			ViewFacebookAdSetLocations,
			object({ useSavedAudienceLocations: optional(boolean()) })
		)
	),

	metaManagerId: optional(nullable(number())),

	syncedAt: stringDate(),
	createdAt: stringDate(),
	updatedAt: stringDate(),
});

export type ViewFacebookAdAccountDto = Infer<typeof ViewFacebookAdAccountDto>;

export type AddFacebookAdAccountDto = Infer<typeof AddFacebookAdAccountDto>;

export const EditFacebookAdAccountDto = partial(AddFacebookAdAccountDto);
export type EditFacebookAdAccountDto = Infer<typeof EditFacebookAdAccountDto>;
